module.exports = __webpack_public_path__ + "img/intr.72ac8e30.png";